// extracted by mini-css-extract-plugin
module.exports = {"AmountSelector":"AmountSelector_AmountSelector__qfyfc","inputRow":"AmountSelector_inputRow__m_3mE"};